<template>
  <div
    class="boxed-frame"
    :class="contentClasses"
  >
    <div class="frame">
      <span class="leading-normal">{{ title }}</span>
      <span />
    </div>

    <div class="boxed-frame-content">
      <slot name="default" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  title: string;
  allowContentScroll?: boolean;
}
const props = defineProps<Props>();

const contentClasses = computed(() => {
  const classes = [];
  if (props.allowContentScroll) {
    classes.push('content-overflow-auto');
  }
  return classes;
});
</script>
